import React, { useEffect, useRef, useState } from "react";

const RevealOnScroll = ({
  as: Element = "div",
  children,
  className = "",
  delay = 0,
  variant = "fade-up",
  ...props
}) => {
  const elementRef = useRef(null);
  const [isObserved, setIsObserved] = useState(false);
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) {
      return undefined;
    }

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (reducedMotion || !("IntersectionObserver" in window)) {
      setIsRevealed(true);
      return undefined;
    }

    setIsObserved(true);
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsRevealed(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: "0px 0px -10% 0px",
        threshold: 0.12,
      },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  const classes = [
    "ws-reveal",
    `ws-reveal--${variant}`,
    isObserved ? "is-observed" : "",
    isRevealed ? "is-revealed" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Element
      ref={elementRef}
      className={classes}
      style={{ "--ws-reveal-delay": `${delay}ms` }}
      {...props}
    >
      {children}
    </Element>
  );
};

export default RevealOnScroll;
